export default {
  INFER_SUBJECT_API_FAIL: 'infer_subject_api_fail',
  OPTION_GENERATION_API_FAIL: 'option_generation_api_fail',
  ALL_OPTION_GENERATION_API_FAIL: 'all_option_generation_api_fail',
};
